module.exports = "/_next/static/images/tv-bottom-35da20d0dba66ffd0f6c54eff31e45c1.png";